var radiansToDegrees = function (radians) { return (radians * 180) / Math.PI; };

export { radiansToDegrees };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/popmotion/dist/es/utils/radians-to-degrees.js
// module id = 89
// module chunks = 0